let obj = {};
obj.SWCJOptions = [
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 200000,
    name: '20万'
  },
  {
    value: 300000,
    name: '30万'
  },
  {
    value: 400000,
    name: '40万'
  },
  {
    value: 500000,
    name: '50万'
  },
  {
    value: 600000,
    name: '60万'
  },
  {
    value: 700000,
    name: '70万'
  },
  {
    value: 800000,
    name: '80万'
  },
  {
    value: 900000,
    name: '90万'
  },
  {
    value: 1000000,
    name: '100万'
  }
];
//性别
obj.sexOptions = [
  {
    name: '男',
    value: 'M'
  },
  {
    name: '女',
    value: 'F'
  }
];
obj.YLFYOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 10000,
    name: '1万'
  },
  {
    value: 20000,
    name: '2万'
  },
  {
    value: 30000,
    name: '3万'
  },
  {
    value: 40000,
    name: '4万'
  },
  {
    value: 50000,
    name: '5万'
  },
  {
    value: 60000,
    name: '6万'
  },
  {
    value: 70000,
    name: '7万'
  },
  {
    value: 80000,
    name: '8万'
  },
  {
    value: 90000,
    name: '9万'
  },
  {
    value: 100000,
    name: '10万'
  },
  {
    value: 110000,
    name: '11万'
  },
  {
    value: 120000,
    name: '12万'
  },
  {
    value: 130000,
    name: '13万'
  },
  {
    value: 140000,
    name: '14万'
  },
  {
    value: 150000,
    name: '15万'
  },
  {
    value: 160000,
    name: '16万'
  },
  {
    value: 170000,
    name: '17万'
  },
  {
    value: 180000,
    name: '18万'
  },
  {
    value: 190000,
    name: '19万'
  },
  {
    value: 200000,
    name: '20万'
  }
];
obj.BASEOptions = [
  {
    value: 0,
    name: '不附加'
  }
];
obj.occupationOptionsLevel = [
  {
    value: '1',
    name: '1类'
  },
  {
    value: '2',
    name: '2类'
  },
  {
    value: '3',
    name: '3类'
  },
  {
    value: '4',
    name: '4类'
  },
  {
    value: '5',
    name: '5类'
  }
];
obj.YLFYBCOptions = [
  {
    value: 0,
    name: '不附加'
  },
  {
    value: 1000,
    name: '1000'
  },
  {
    value: 2000,
    name: '2000'
  },
  {
    value: 3000,
    name: '3000'
  },
  {
    value: 4000,
    name: '4000'
  },
  {
    value: 5000,
    name: '5000'
  }
];
export default { ...obj };
